import React from "react";

const githubcontibution = () => {
  return (
    <>
      <img
        src="https://ghchart.rshah.org/igorhristov"
        alt="igor hristov github contribution chart"
        style={{ width: "100%"}}
      />
    </>
  );
};

export default githubcontibution;
